<template>
    <div class="mainBox">
		<div class="d_title">
            <el-page-header @back="goBack" content="单页管理"></el-page-header>
		</div>
		<el-form ref="updateForm" :model="updateForm" :rules='formItemRules' label-width="80px" size="medium">
            <el-form-item prop='language' label='语言'>
                <el-select v-model="updateForm.language" placeholder="请选择语言" clearable>
                    <el-option label="中文" value="cn"></el-option>
                    <el-option label="英文" value="en"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item prop='title' label='标题'>
                <el-input v-model="updateForm.title" placeholder='请输入标题' clearable></el-input>
            </el-form-item>
            <el-form-item prop='content' label='内容' class="quill-form-item">
                <quill-editor v-model="updateForm.content"></quill-editor>
            </el-form-item>
            <el-form-item>
                <el-button size="medium" @click="handleReset2">重置</el-button>
                <el-button size="medium" type="primary" @click="onSubmitForm">确定</el-button>
            </el-form-item>
        </el-form>
	</div>
</template>

<script>
    import {singleDetail,singleCreate,singleUpdate} from '@/utils/getData';
    import quillEditor from '@/components/quill'

    export default {
        name: "singleEdit",
        props:["id"],
        components:{
            quillEditor
        },
        data(){
            return{
                updateForm: {
                    title: "",
                    content: ""
                },
                formItemRules: {
                    language: [{
                        required: true,
                        message: '请选择语言',
                        trigger: 'change'
                    }],
                    title: [{
                        required: true,
                        message: '请输入标题',
                        trigger: 'blur'
                    }],
                    content: [{
                        required: true,
                        message: '请输入内容',
                        trigger: 'blur'
                    }]
                },
            }
        },
        mounted(){
            if(this.id){//编辑
                this.init();
            }else{
                this.updateForm = {};
            }
        },
        methods:{
            async init(){
                try {
                    let res = await singleDetail(this.id);
                    if (res.code == 0) {
                        this.updateForm = res.data;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type: 'error'
                        });
                    }
                } catch(e) {
                    this.$message({
                        showClose:true,
                        message: e.message,
                        type: 'error'
                    });
                }
            },
            onSubmitForm() { //提交表单
                let that = this;
                this.$refs['updateForm'].validate(async (valid) => {
                    try{
                        if (valid) {
                            let formData = that.updateForm;
                            let res = {};
                            if (this.id) {
                                // 编辑状态
                                res = await singleUpdate(that.updateForm.id, formData);
                            } else {
                                // 新增状态
                                res = await singleCreate(formData);
                            }
                            if (res.code == 0) {
                                this.$message({
                                    showClose: true,
                                    message: '保存成功',
                                    type: 'success'
                                });
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: res.message,
                                    type: 'error'
                                });
                            }
                        }
                    }catch (e) {
                        this.$message({
                            showClose:true,
                            message: e.message,
                            type: 'error'
                        });
                    }
                });
            },
            handleReset2(){//重置密码表单
                this.$refs["updateForm"].resetFields();
            },
            goBack(){
                this.$router.push('/single');
            }
        }
    }
</script>

<style scoped>
    .d_title{border-bottom:2px solid #999;margin-bottom:30px;position:relative;padding-bottom:10px;}
	.mainCt{padding:10px 20px;}
    .quill-form-item >>>.el-form-item__content{line-height: 1;}
</style>